// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/forbes.scss
// module id = 3
// module chunks = 0